<!--
 * @Description: 
 * @Version: 2.0
 * @Autor: lau
 * @Date: 2022-08-24 09:37:22
 * @LastEditors: lau
 * @LastEditTime: 2022-08-24 09:37:32
-->
<!--
 * @Description: 
 * @Version: 2.0
 * @Autor: lau
 * @Date: 2022-08-19 15:55:16
 * @LastEditors: lau
 * @LastEditTime: 2022-08-23 15:36:11
-->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "recordId":"",
                "status":"",
                "remark":"",
                "operator":""

            },
            responseCode: 	{
                "data": {
                },
                "message": "业务成功",
                "resultCode": 0,
                "status": 1
            },infoData: {
                explain: "第三方接入系统请求智慧停车开放平台根据支付订单号更新代扣流程记录的订单回调时间和支付状态",
                t_url: this.commonUrls.test+"updateWihholdDetailBill",
                p_url: this.commonUrls.prod+"updateWihholdDetailBill",
                precondition: "无",
                fitSystem: "VEMS传统停车场, 云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                    { info1: 'thirdBillCode', info2: '是', info3: 'String', info4: '第三方订单号' },
                    { info1: 'billStatus', info2: '是', info3: 'Integer', info4: '订单的支付状态（0:等待支付;1:支付成功;2:支付失败;3:订单退款）' },
                    { info1: 'billCallbackDate', info2: '是', info3: 'String', info4: '订单的回调时间,yyyy-MM-dd HH:mm:ss' },
                     
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        
                        ]
                }
            
            ],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/parking/record/updateWihholdDetailBill.vue